import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withTranslation, Trans } from 'react-i18next'
import { ResponsivePie } from '@nivo/pie'

import EditorMain from './Editor'
import ShareProjectOptions from '../Modal/ShareProjectOptions'
import Upgrade from '../Modal/Upgrade'
import Modal from '../Modal'

import { IconEditPencil } from '../../svg'
import preview_img from '../../images/preloader.gif'

import { API__PROJECTS } from '../../api'
import Toast from '../../common/components/Toast/Toast'
// import UpgradeModal from '../Modal/UpgradeModal'
import LoadEllipsis from '../../svg/loadEllipsis.svg'
import AlertRed from '../../images/icons/allert-red.png'
import AlertWhite from '../../images/icons/allert-white.png'

// import { convertArrayToObject } from '../../utils/common'

class PublishTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            publish_modal: {
                is_open: false,
                data: {
                    project: null,
                    share_entities: null,
                },
            },
            upgrade_modal: {
                is_open: false,
            },
            custom_project_id_modal: {
                is_open: false,
                value: '',
                status: '',
                can_check: false,
                can_save: false,
            },

            main_image_canvas: null,

            custom_project_id_available: null,
            custom_project_id: null,
        }
        this.base_state = this.state

        this.customProjectIdRef = React.createRef()
    }

    async componentDidMount() {
        const { user_subscription, project } = this.props

        const index = user_subscription.product.featureProducts.findIndex(
            item => item.featureType === 'CUSTOM_PROJECT_URL',
        )

        await this.setState({
            custom_project_id_available: index !== -1,
            custom_project_id: project.customUrl,
        })

        if (project.projectType.customId === 'PERSONALITY') {
            this.props.events.updatePersonalityDistribution().then()
        }

        if (project.projectType.customId === 'TRIVIA') {
            this.props.events.updateTriviaDistribution().then()
        }

        const share_entities = await EditorMain.getEditedAppSharedOptions()
        const main_image_canvas = await EditorMain.getHtmlPreview(share_entities.previewHtml)

        await this.setState(prevState => ({
            main_image_canvas,
            publish_modal: {
                ...prevState.publish_modal,
                data: {
                    ...prevState.publish_modal.data,
                    share_entities,
                },
            },
        }))
    }

    componentWillUnmount() {}

    handleClick__check_custom_project_url = async () => {
        try {
            this.setState(prevState => ({
                custom_project_id_modal: {
                    ...prevState.custom_project_id_modal,
                    status: '',
                },
            }))

            const { custom_project_id_modal } = this.state
            const response_1 = await API__PROJECTS.CHECK_CUSTOM_URL(custom_project_id_modal.value)
            switch (response_1.status) {
                case 'FREE': {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            status: 'free',
                        },
                    }))
                    break
                }
                case 'ALREADY_TAKEN': {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            status: 'already_taken',
                        },
                    }))
                    break
                }
                default:
                    break
            }
        } catch (err) {
            console.error(err)

            if (err.response) {
                const {
                    response: { status },
                } = err
                if (status === 403) {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            is_open: false,
                        },
                        upgrade_modal: {
                            ...prevState.upgrade_modal,
                            is_open: true,
                        },
                    }))
                    return
                }
                if (status === 422) {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            status: 'invalid',
                        },
                    }))
                    return
                }
            }

            Toast('error', {})
        }
    }
    handleClick__save_custom_project_url = async () => {
        try {
            const { project, events } = this.props
            const { custom_project_id_modal } = this.state
            await API__PROJECTS.SET_CUSTOM_URL(project.projectId, custom_project_id_modal.value)

            this.setState(prevState => ({
                custom_project_id: custom_project_id_modal.value,
                custom_project_id_modal: {
                    ...prevState.custom_project_id_modal,
                    is_open: false,
                },
            }))

            await events.change_project({
                customUrl: custom_project_id_modal.value,
            })

            Toast('success', {
                title: this.props.t('Saved'),
                time: 2000,
            })
        } catch (err) {
            console.error(err)

            if (err.response) {
                const {
                    response: { status },
                } = err
                if (status === 400) {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            status: 'already_taken',
                        },
                    }))
                    return
                }
                if (status === 403) {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            is_open: false,
                        },
                        upgrade_modal: {
                            ...prevState.upgrade_modal,
                            is_open: true,
                        },
                    }))
                    return
                }
                if (status === 422) {
                    this.setState(prevState => ({
                        custom_project_id_modal: {
                            ...prevState.custom_project_id_modal,
                            status: 'invalid',
                        },
                    }))
                    return
                }
            }

            Toast('error', {})
        }
    }
    handleClick__toggle_custom_project_url = async () => {
        try {
            const { custom_project_id } = this.state
            if (custom_project_id) {
                const { project, events } = this.props
                await API__PROJECTS.DELETE_CUSTOM_URL(project.projectId)

                this.setState(prevState => ({
                    custom_project_id: null,
                    custom_project_id_modal: {
                        ...prevState.custom_project_id_modal,
                        is_open: false,
                    },
                }))

                await events.change_project({
                    customUrl: null,
                })
            } else {
                this.handleClick__open_custom_id_modal()
            }
        } catch (err) {
            console.error(err)

            Toast('error', {})
        }
    }

    handleClick__open_publish_modal = async () => {
        const { og_info, project } = this.props

        await this.setState(prevState => ({
            publish_modal: {
                ...prevState.publish_modal,
                is_open: true,
                data: {
                    ...prevState.publish_modal.data,
                    og_info,
                    project,
                },
            },
        }))
    }
    handleClick__close_publish_modal = () => {
        this.setState(prevState => ({
            publish_modal: {
                ...prevState.publish_modal,
                is_open: false,
            },
        }))
    }

    handleClick__open_custom_id_modal = async () => {
        const { custom_project_id_available, custom_project_id } = this.state

        if (custom_project_id_available !== null) {
            if (custom_project_id_available) {
                await this.setState(prevState => ({
                    custom_project_id_modal: {
                        ...prevState.custom_project_id_modal,
                        is_open: true,
                        value: custom_project_id !== null ? custom_project_id : '',
                    },
                }))
                this.customProjectIdRef.focus()
            } else {
                await this.setState(prevState => ({
                    upgrade_modal: {
                        ...prevState.upgrade_modal,
                        is_open: true,
                    },
                }))
            }
        }
    }
    handleClick__close_upgrade_modal = () => {
        this.setState(prevState => ({
            upgrade_modal: {
                ...prevState.upgrade_modal,
                is_open: false,
            },
        }))
    }

    handleClick__close_custom_project_id_modal = () => {
        this.setState(prevState => ({
            custom_project_id_modal: {
                ...prevState.custom_project_id_modal,
                is_open: false,
            },
        }))
    }

    handleChange__custom_project_id_value = async evt => {
        evt.persist()
        try {
            const { custom_project_id } = this.state

            await this.setState(prevState => ({
                custom_project_id_modal: {
                    ...prevState.custom_project_id_modal,
                    value: evt.target.value,
                    status: '',
                    can_check: evt.target.value.length,
                    can_save: evt.target.value.length && evt.target.value !== custom_project_id,
                },
            }))
        } catch (err) {
            console.error(err)
        }
    }

    onBlur = async evt => {
        evt.preventDefault()

        this.setState(prevState => ({
            custom_project_id_modal: {
                ...prevState.custom_project_id_modal,
                status: '',
            },
        }))
    }
    onFocus = async evt => {
        evt.preventDefault()

        this.setState(prevState => ({
            custom_project_id_modal: {
                ...prevState.custom_project_id_modal,
                status: 'focus',
            },
        }))
    }

    render() {
        const {
            events,
            og_info,
            project,
            t,
            data: { personalityDistribution, triviaDistribution },
        } = this.props
        const {
            publish_modal,
            main_image_canvas,
            custom_project_id,
            upgrade_modal,
            custom_project_id_modal,
        } = this.state

        let main_background_image
        let main_image_loading
        if (!og_info.custom_image) {
            main_image_loading = !main_image_canvas
            main_background_image = `${
                main_image_canvas ? main_image_canvas.toDataURL('image/png', 0.95) : preview_img
            }`
        } else {
            main_background_image = og_info.image_url
        }

        let compact_view = true

        let personalityDataFormatted = null
        if (project.projectType.customId === 'PERSONALITY') {
            compact_view = false

            const graphColors = [
                '#F47560',
                '#61CCBB',
                '#F1E05C',
                '#5E9EFF',
                '#8BDA4D',
                '#F460A7',
                '#FF9C54',
                '#926AD3',
                '#2CA983',
                '#D3A287',
                // other
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
            ]

            if (!personalityDistribution.isLoading && personalityDistribution.data) {
                personalityDataFormatted = {}
                personalityDataFormatted.hasError = personalityDistribution.data._collision.results.neverShow.length
                personalityDataFormatted.correctResults = personalityDistribution.data.results
                    .filter(el => personalityDistribution.data._collision.results.neverShow.indexOf(el.screenId) === -1)
                    .map((item, index) => {
                        return { ...item, color: graphColors[index] }
                    })
                personalityDataFormatted.errorResults = personalityDistribution.data.results.filter(
                    el => personalityDistribution.data._collision.results.neverShow.indexOf(el.screenId) !== -1,
                )

                personalityDataFormatted.graphData = personalityDataFormatted.correctResults.map(item => {
                    const roundedPercentage = Math.round(
                        personalityDistribution.data._probability[item.screenId].percentage,
                    )
                    return {
                        id: item.screenId,
                        value: roundedPercentage,
                        label: roundedPercentage + '%',
                        color: item.color,
                    }
                })
            }
        }

        let triviaDataFormatted = null
        if (project.projectType.customId === 'TRIVIA') {
            compact_view = false

            const graphColors = [
                '#F47560',
                '#61CCBB',
                '#F1E05C',
                '#5E9EFF',
                '#8BDA4D',
                '#F460A7',
                '#FF9C54',
                '#926AD3',
                '#2CA983',
                '#D3A287',
                // other
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
                '#2990fb',
            ]

            if (!triviaDistribution.isLoading && triviaDistribution.data) {
                triviaDataFormatted = {}
                triviaDataFormatted.hasError = false
                triviaDataFormatted.results = triviaDistribution.data._probability.map((item, index) => {
                    return { ...item, color: graphColors[index] }
                })

                const rangeSum = triviaDataFormatted.results.reduce((a, b) => a + b.range, 0)
                triviaDataFormatted.graphData = triviaDataFormatted.results.map(item => {
                    return {
                        label: item.min !== item.max ? `${item.min}-${item.max}` : item.min,
                        width: Math.round(((item.range * 100) / rangeSum) * 100) / 100,
                        color: item.color,
                    }
                })
            }
        }

        const TitleAndDescription = () => {
            let title = t('_components._editor._tabs._review.title')
            let description = t('_components._editor._tabs._review.text')

            if (project.projectType.customId === 'PERSONALITY') {
                if (personalityDistribution.isLoading || !personalityDataFormatted) {
                    return (
                        <div className="loading-title">
                            <img src={LoadEllipsis} alt="loading" />
                        </div>
                    )
                } else {
                    if (personalityDataFormatted.hasError) {
                        title = t('_components._editor._tabs._review._personality.error_title')
                        description = t('_components._editor._tabs._review._personality.error_text')
                    }
                }
            }

            if (project.projectType.customId === 'TRIVIA') {
                if (triviaDistribution.isLoading || !triviaDataFormatted) {
                    return (
                        <div className="loading-title">
                            <img src={LoadEllipsis} alt="loading" />
                        </div>
                    )
                } else {
                    if (triviaDataFormatted.hasError) {
                        // show trivia errors ?
                    }
                }
            }

            return (
                <>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </>
            )
        }

        return (
            <div className="editor-tab--publish">
                <TitleAndDescription />

                <div className="wrap-window">
                    <div className="boxes">
                        {project.projectType.customId === 'PERSONALITY' ? (
                            <div className="box box--personality">
                                <h3>
                                    {personalityDataFormatted && personalityDataFormatted.hasError ? (
                                        <img src={AlertRed} alt="alert-red" />
                                    ) : null}
                                    {t('_components._editor._tabs._review._boxes._personality.title')}
                                </h3>
                                {personalityDistribution.isLoading || !personalityDataFormatted ? (
                                    <div className="loading">
                                        <img src={LoadEllipsis} alt="loading" />
                                    </div>
                                ) : (
                                    <>
                                        <div className="workplace">
                                            <div className="graph">
                                                <ResponsivePie
                                                    data={personalityDataFormatted.graphData}
                                                    margin={{ top: 1, right: 1, bottom: 1, left: 1 }}
                                                    borderWidth={1}
                                                    borderColor={'#FFF'}
                                                    colors={d => d.color}
                                                    enableRadialLabels={false}
                                                    innerRadius={0.6}
                                                    sliceLabel={d => d.label}
                                                    slicesLabelsTextColor={'#000'}
                                                    isInteractive={false}
                                                    // onClick={d => console.log('d:', d)}
                                                />
                                            </div>
                                            <div className="list">
                                                <ul>
                                                    {personalityDataFormatted.correctResults.map(el => {
                                                        return (
                                                            <li key={el.screenId} title={el.text}>
                                                                <span style={{ backgroundColor: el.color }}></span>
                                                                <p>{el.text}</p>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                                {personalityDataFormatted.hasError ? (
                                                    <>
                                                        <p>
                                                            {t(
                                                                '_components._editor._tabs._review._boxes._personality.never_visible',
                                                            )}
                                                        </p>
                                                        <ul>
                                                            {personalityDataFormatted.errorResults.map(el => {
                                                                return (
                                                                    <li key={el.screenId} title={el.text}>
                                                                        <img src={AlertWhite} alt="alert-white" />
                                                                        <p>{el.text}</p>
                                                                    </li>
                                                                )
                                                            })}
                                                        </ul>
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="btns">
                                            <button
                                                className="button"
                                                data-size="md"
                                                data-variant="secondary-white"
                                                onClick={evt => this.props.events.open_personality_modal()}
                                            >
                                                {t('Edit')}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : null}
                        {project.projectType.customId === 'TRIVIA' ? (
                            <div className="box box--trivia">
                                <h3>
                                    <Trans i18nKey="_components._editor._tabs._review._boxes._trivia.title" />
                                </h3>
                                {triviaDistribution.isLoading || !triviaDataFormatted ? (
                                    <div className="loading">
                                        <img src={LoadEllipsis} alt="loading" />
                                    </div>
                                ) : (
                                    <>
                                        <div className="workplace">
                                            <p>
                                                {t(
                                                    '_components._editor._tabs._review._boxes._trivia.number_of_answers',
                                                )}
                                            </p>
                                            <ul className="graph">
                                                {triviaDataFormatted.graphData.map(el => {
                                                    return (
                                                        <li
                                                            style={{ backgroundColor: el.color, width: `${el.width}%` }}
                                                            key={el.screenId}
                                                        >
                                                            {el.label}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                            <ul className="map">
                                                {triviaDataFormatted.graphData.map((el, index) => {
                                                    return (
                                                        <li key={el.screenId}>
                                                            <span style={{ backgroundColor: el.color }}></span>
                                                            {t(
                                                                '_components._editor._tabs._review._boxes._trivia.result',
                                                            )}{' '}
                                                            {index + 1}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                        <div className="btns">
                                            <button
                                                className="button"
                                                data-size="md"
                                                data-variant="secondary-white"
                                                onClick={events.change_step(0)}
                                            >
                                                {t('Edit')}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        ) : null}
                        <div className="box">
                            <h3>{t('_components._editor._tabs._review._boxes._sharing_options.title')}</h3>
                            <div className="inner-box">
                                <div
                                    className={`preview-img${main_image_loading ? ' is-loading' : ''}`}
                                    style={{
                                        backgroundImage: `url(${main_background_image})`,
                                    }}
                                ></div>
                                <div className="text">
                                    <div className="title">{og_info.title}</div>
                                    <div className="description">{og_info.description}</div>
                                </div>
                            </div>
                            <div className="btns">
                                <button
                                    className="button"
                                    data-size="md"
                                    data-variant="secondary-white"
                                    disabled={!main_image_canvas}
                                    onClick={this.handleClick__open_publish_modal}
                                >
                                    {t('Edit')}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/*if we have more only one box in boxes add class "compact"*/}
                    <div className={`custom-url-box${compact_view ? ' compact' : ''} `}>
                        <div className="side side--left">
                            <div
                                className={`switcher${custom_project_id ? ' is-checked' : ''}`}
                                onClick={this.handleClick__toggle_custom_project_url}
                            ></div>
                            <p>{t('_components._editor._tabs._review._boxes._custom_url.title')}</p>
                            {custom_project_id ? (
                                <span className="edit-btn" onClick={this.handleClick__open_custom_id_modal}>
                                    <IconEditPencil />
                                </span>
                            ) : null}
                        </div>
                        <div className="side side--right">
                            {`https://${window.location.host}/projects/`}
                            <div className="project_id">
                                {custom_project_id ? (
                                    <span>{custom_project_id}</span>
                                ) : (
                                    <span className="ph">best_project_name</span>
                                )}
                            </div>

                            {custom_project_id ? (
                                <span className="edit-btn" onClick={this.handleClick__open_custom_id_modal}>
                                    <IconEditPencil />
                                </span>
                            ) : null}
                        </div>
                    </div>
                </div>

                {upgrade_modal.is_open ? (
                    <Upgrade
                        is_open={true}
                        overlay_close={true}
                        settings={{ max_width: 640 }}
                        events={{
                            on_close: this.handleClick__close_upgrade_modal,
                            init_action: events.init_action,
                        }}
                        necessary_features={[
                            { tariff: 'Professional', description: t('_components._modal._upgrade.option') },
                        ]}
                    />
                ) : null}

                {custom_project_id_modal.is_open ? (
                    <Modal
                        settings={{ overlay_close: false }}
                        classes={{ overlay: '', modal: 'share-style', closeButton: '', closeIcon: '' }}
                        data={{ open: true, max_width: 960 }}
                        events={{ onCloseModal: this.handleClick__close_custom_project_id_modal }}
                    >
                        <div className="head head-v1">{t('_components._modal._custom_project_link.title')}</div>

                        <div className="wrap-custom-project-id">
                            <h2>{t('_components._modal._custom_project_link.text_1')}</h2>
                            <p>{t('_components._modal._custom_project_link.text_2')}</p>
                            {/*statuses: free, already_taken, invalid*/}
                            <div className={`input-place ${custom_project_id_modal.status}`}>
                                <div className="side side--left">
                                    <div className="placeholder">{`https://${window.location.host}/projects/`}</div>
                                    <input
                                        type="text"
                                        maxLength={25}
                                        ref={input => {
                                            this.customProjectIdRef = input
                                        }}
                                        placeholder="best_project_name"
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        value={custom_project_id_modal.value}
                                        onChange={this.handleChange__custom_project_id_value}
                                    />
                                </div>
                                <div className="side side--right">
                                    {custom_project_id_modal.status === '' ||
                                    custom_project_id_modal.status === 'focus' ? (
                                        <button
                                            className="button"
                                            data-size="lg"
                                            data-variant="primary"
                                            onClick={this.handleClick__check_custom_project_url}
                                            disabled={!custom_project_id_modal.can_check}
                                        >
                                            {t('_components._modal._custom_project_link.check_availability')}
                                        </button>
                                    ) : null}
                                    {custom_project_id_modal.status === 'free' ? (
                                        <div className="available">{t('_common.available')}</div>
                                    ) : null}
                                    {custom_project_id_modal.status === 'already_taken' ? (
                                        <div className="unavailable">{t('_common.unavailable')}</div>
                                    ) : null}
                                    {custom_project_id_modal.status === 'invalid' ? (
                                        <div className="invalid">{t('_common.invalid_characters')}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="note">
                                {t('_components._modal._custom_project_link.max_length_25')}
                                <br />
                                {t('_components._modal._custom_project_link.allowed_characters')}
                            </div>
                            <ul className="allowed">
                                <li>a-z</li>
                                <li>A-Z</li>
                                <li>0-9</li>
                                <li>-</li>
                                <li>_</li>
                            </ul>
                            <div className="buttons">
                                <button
                                    className="button"
                                    data-size="lg"
                                    data-variant="secondary"
                                    onClick={this.handleClick__close_custom_project_id_modal}
                                >
                                    {t('Cancel')}
                                </button>
                                <button
                                    className="button"
                                    data-size="lg"
                                    data-variant="primary"
                                    disabled={!custom_project_id_modal.can_save}
                                    onClick={this.handleClick__save_custom_project_url}
                                >
                                    {t('_common.save')}
                                </button>
                            </div>
                        </div>
                    </Modal>
                ) : null}

                {publish_modal.is_open ? (
                    <ShareProjectOptions
                        is_open={true}
                        overlay_close={true}
                        data={{ ...publish_modal.data, main_image_canvas }}
                        classes={{
                            overlay: '',
                            modal: 'share-style share-options-style',
                            closeButton: '',
                            closeIcon: '',
                        }}
                        settings={{ max_width: 960 }}
                        events={{
                            on_close: this.handleClick__close_publish_modal,
                            change_og_info: events.change_og_info,
                            init_save_silent: events.init_action('save--silent'),
                            on_open_asset_manager: this.handleClick__open_asset_manager_modal,
                        }}
                    />
                ) : null}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    user_subscription: state.user_subscription,
})

export default compose(connect(mapStateToProps, null), withTranslation('translations'))(PublishTab)
